import React from 'react';
import { Link } from 'react-router-dom';
import { funnel } from '../data/mockData';
export function FunnelCard() {
  return <section className="rounded-xl border border-gray-200 bg-white" aria-labelledby="funnel-heading" data-id="element-98" data-mp="ot8i5oxorina">
      <div className="flex items-center justify-between border-b border-gray-200 px-5 py-3.5" data-id="element-99" data-mp="12kn4a4mw3zyk">
        <h2 id="funnel-heading" className="text-[14px] font-semibold text-ink" data-id="element-100" data-mp="xrc4uokeqlgo">
          Your funnel · last 30 days
        </h2>
        <Link to="/reports" className="text-[12.5px] font-medium text-brand hover:text-brand-dark" data-id="element-101" data-mp="17if55o5iiwew">
          Reports
        </Link>
      </div>

      <div className="space-y-3 px-5 py-5" data-id="element-102" data-mp="1lhesmshah59h">
        {funnel.map(step => <div key={step.label} className="flex items-center gap-4" data-id="element-103" data-mp="1hhxl7tiaxy1o">
            <span className="w-20 shrink-0 text-[12.5px] text-gray-600" data-id="element-104" data-mp="3n8t04jajywls">
              {step.label}
            </span>
            <span className="h-2.5 flex-1 overflow-hidden rounded-full bg-gray-100" data-id="element-105" data-mp="3j9as2o3tyg0d">
              <span className="block h-full rounded-full" style={{
            width: `${step.value / step.max * 100}%`,
            backgroundColor: step.color
          }} data-id="element-106" data-mp="2hrd01rpt7jm" />
            </span>
            <span className="w-10 shrink-0 text-right text-[12.5px] font-medium text-ink" data-id="element-107" data-mp="cdclmirah62c">
              {step.value}
            </span>
          </div>)}
      </div>

      <p className="border-t border-gray-100 px-5 py-3 text-[12px] text-gray-500" data-id="element-108" data-mp="m4pcp859js7b">
        17.2% of assigned leads reached submission in the last 30 days. Biggest
        drop-off: contacted → engaged.
      </p>
    </section>;
}